/* 我要询价 */
<template>
  <lay-out>
    <div class="my-inquiry">
      <div class="mem-page-title">开始询价</div>
      <div class="select">
        <span class="title">请选择要询价的项目</span>
        <Select
          v-model="projectChoiced"
          @on-change="changeSelect"
          style="width:300px"
          class="select-bg"
        >
          <Option v-for="item in inquiryLists" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <span class="create">
          还没有项目？
          <span @click="addProjectHandle">去创建</span>
        </span>
      </div>
      <div class="detailsCon">
        <a :href="`${VUE_APP_NEXT_BASIC_URL}/products/${projectChoiced}?locationId=${locationId}`" target="_blank">
          <span> 进入项目 > </span>
        </a>
      </div>
      <div class="my-inquiry-main">
        <projects :projectChoiced="projectChoiced"></projects>
      </div>
    </div>
    <z-projectlog
      :display="model"
      :loading="BUTTON_NAME['CREATE_PROJECT']"
      @close="closeDialog"
      @submitHandle="submitHandle"
      :VUE_APP_OLD_BASIC_URL="VUE_APP_OLD_BASIC_URL"
      :bookInfo="bookInfo"
      title="创建新项目"
      btnTxt="确定"
      width="500"
    ></z-projectlog>
  </lay-out>
</template> 
<script>
import axios from "axios";
import LayOut from "./layout";
import Projects from "../../Project/common/Products.vue";
import router from "@/router";
import { setTimeout } from "timers";
import { reject } from "q";
/* 全局修改url */
function setParams(id, oldId = null) {
  let _id = oldId ? oldId : "replace";

  if (oldId) {
    console.log(window.location.href.split(_id)[0]);
  } else {
    let awaitParams = window.history.pushState(
      {},
      "住逻辑",
      `${window.location.href.split(_id)[0]}${id}`
    );
  }
}
export default {
  data() {
    return {
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      VUE_APP_NEXT_BASIC_URL: process.env.VUE_APP_NEXT_BASIC_URL,
      inquiryLists: [],
      projectChoiced: "",
      setParams: setParams,
      locationId: "",
      model: false
    };
  },
  beforeRouteEnter(to, from, next) {
    axios.get(`/designer_api/projects/select/project`).then(res => {
      next(vm => {
        if (res && res.length > 0) {
          vm.inquiryLists = res;
          vm.projectChoiced = res[0].id;
          if (to.params.id === "replace") {
            setParams(vm.projectChoiced);
          }
          vm.$store.dispatch("permission", {
            projectId: vm.projectChoiced
          });
          vm.getProjectDetail(vm.projectChoiced);
        }
      });
    });
  },
  components: {
    LayOut,
    Projects
  },
  computed: {
    BUTTON_NAME() {
      return this.$store.state.BUTTON_NAME;
    },
    bookInfo() {
      return this.$store.state.bookInfo;
    }
  },
  methods: {
    getProjectDetail(id) {
      axios.get(`/designer_api/projects/${id}`).then(res => {
        this.projectDetail = res;
        this.locationId = res.locationId;
        setParams(id, this.$route.params.id);
        this.$store.dispatch("getProjectDetails", res);
      });
    },
    getInquiryList() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/designer_api/projects/select/project`)
          .then(res => {
            this.inquiryLists = res;
            resolve(this.inquiryLists);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    changeSelect(val) {
      this.projectChoiced = val;
      this.getProjectDetail(val);
    },

    addProjectHandle() {
      this.model = true;
    },

    closeDialog() {
      this.model = false;
    },

    /* 添加项目 */
    submitHandle(params) {
      Object.assign(params);
      if (params.type === 1) {
        params.companyAuthId = null;
      }
      axios
        .post(`/designer_api/projects/create/v1`, params, {
          btn_loading: "CREATE_PROJECT"
        })
        .then(res => {
          this.model = false;
          this.$Message.success("添加成功");
          this.getInquiryList(res => {
            setParams(res.projectChoiced, this.projectChoiced);
            this.$store.dispatch("permission", {
              projectId: res.projectChoiced
            });
            this.getProjectDetail(res.projectChoiced);
          });
        })
        .catch(err => {
          this.model = false;
        });
    }
  },
  created() {
    this.$store.dispatch("getBookInfo");
  },
  mounted() {
    this.$store.dispatch("getOssKey", 2);
  }
};
</script>  

<style lang="scss">
.my-inquiry {
  background: #fff;
  min-height: 600px;
  .select {
    margin-left: 30px;
    margin-top: 25px;
    > span {
      display: inline-block;
      font-size: 18px;
      font-weight: 500;
      color: rgba(49, 49, 49, 1);
      vertical-align: middle;
      margin-right: 20px;
    }
    .create {
      font-size: 18px;
      font-weight: 500;
      color: rgba(49, 49, 49, 1);
      display: inline-block;
      margin-left: 30px;
      span {
        font-size: 18px;
        font-weight: 500;
        color: #ec6464;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  &-main {
    padding: 50px 30px;
    .pro-products .pro-products-button .right {
      margin-bottom: 0px !important;
      width: 305px !important;
    }
  }
  .detailsCon {
    margin-top: 30px;
    padding: 0 30px;
    text-align: right;
    margin-bottom: -35px;
    span {
      cursor: pointer;
      color: #a0a0a0;
      &:hover {
        text-decoration: underline;
        color: #313131;
      }
    }
  }
}
</style>